import type { handleUrlsProps } from './types'

export const handleUrls = (props: handleUrlsProps) => {
  const { publicationUrl, baseUrl, imageUrl } = props

  let publicationHref: string | undefined
  let imageHref: string | undefined

  try {
    publicationHref = publicationUrl ? new URL(publicationUrl).href : ''
    imageHref = imageUrl && baseUrl ? new URL(imageUrl, baseUrl).href : ''
  } catch (e: unknown) {
    imageHref = ''
  }

  return {
    punnycode: { url: publicationHref, image: imageHref },
    utf: { url: undefined, image: undefined },
  }
}
